<template>
    <div class="product-container">
        <nav class="add-navigation">
            <div class="custom-row row w-75">
                <div class="col col-lg-4 col-md-5 col-xs-12">
                    <search-input
                            class="search-input"
                            type="text"
                            v-model="SearchTemplate"
                            placeholder="Search for template"
                    />
                </div>
            </div>
            <div class="buttons-wrapper w-25">
                <div class="primary-button">
                    <primary-button
                            @click.native="$router.push({name: 'company-admin-add-template'})"
                    >Add Template
                    </primary-button>
                </div>
            </div>
        </nav>
        <loader :loading="loading" v-if="loading"/>
        <template v-if="!loading">
            <not-found v-if="isFound"/>
            <div v-else class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
                <table class="Invoice_table">
                    <thead>
                    <tr class="Invoice_table_header">
                        <th class="Name">Template Name</th>
                        <th class="CreatedOn">Created On</th>
                        <th class="CreatedBy">Created By</th>
                        <th class="smsText">SMS Text</th>
                        <th class="action">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="template in allTemplates" :key="template.templateId">
                        <th>{{template.templateName}}</th>
                        <th>{{template.createdOn}}</th>
                        <th class="created_by">
                            <!-- <img class="popup_image" src="@/assets/person.jpg" alt /> -->
                            {{template.createdBy}}
                        </th>
                        <th
                                :title="template.smsText.length > 60 ? template.smsText : ''"
                                class="smsText"
                        >{{template.smsText | shortText}}
                        </th>
                        <th class="action">
                          <span v-if="template.status == 'rejected'" title="Inactive">
                            <svg
                                    @click="approveTemplate(template.templateId)"
                                    class="thumb"
                                    width="20px"
                                    height="20px"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 472 515"
                            >
                                <g
                                        data-v-35e80b9a
                                        id="Group_511"
                                        data-name="Group 511"
                                        transform="translate(130.667 45.667)"
                                >
                                    <g data-v-35e80b9a id="Group_510" data-name="Group 510">
                                        <path
                                                data-v-35e80b9a
                                                id="Path_847"
                                                data-name="Path 847"
                                                d="M512,186.667a47.306,47.306,0,0,1-13.888,33.579,52.966,52.966,0,0,1,13.653,40.725c-2.5,27.115-26.923,48.363-55.637,48.363H324.352c6.528,19.819,16.981,56.149,16.981,85.333,0,46.272-39.317,85.333-64,85.333-22.165,0-37.995-12.48-38.677-12.992a10.719,10.719,0,0,1-3.989-8.341V386.326l-61.44-133.1-2.56-1.3V23.275C188.032,15.083,210.005,10.667,224,10.667H419.819c23.232,0,43.563,15.659,48.341,37.269A47.99,47.99,0,0,1,464.3,79.979,47.782,47.782,0,0,1,485.654,144,47.755,47.755,0,0,1,512,186.667Z"
                                                transform="translate(-170.667 -10.667)"
                                                fill="#d2305b"
                                        />
                                    </g>
                                </g>
                                <rect
                                        data-v-35e80b9a
                                        id="Rectangle_135"
                                        data-name="Rectangle 135"
                                        width="102"
                                        height="309"
                                        fill="#d2305b"
                                />
                            </svg>
                          </span>
                          <span v-else-if="template.status == 'approved'" title="Active">
                                  <svg
                                          @click="rejectTemplate(template.templateId)"
                                          class="thumb"
                                          width="20px"
                                          height="20px"
                                          xmlns="http://www.w3.org/2000/svg"
                                          viewBox="0 0 472 515"

                                  >
                  <g
                          data-v-35e80b9a
                          id="like_5_"
                          data-name="like (5)"
                          transform="translate(-40 -10.667)"
                  >
                    <g data-v-35e80b9a id="Group_511" data-name="Group 511">
                      <g data-v-35e80b9a id="Group_510" data-name="Group 510">
                        <path
                                data-v-35e80b9a
                                id="Path_847"
                                data-name="Path 847"
                                d="M512,304a47.306,47.306,0,0,0-13.888-33.579A52.966,52.966,0,0,0,511.765,229.7c-2.5-27.115-26.923-48.363-55.637-48.363H324.352c6.528-19.819,16.981-56.149,16.981-85.333,0-46.272-39.317-85.333-64-85.333-22.165,0-37.995,12.48-38.677,12.992A10.719,10.719,0,0,0,234.667,32v72.341l-61.44,133.1-2.56,1.3V467.392C188.032,475.584,210.005,480,224,480H419.819c23.232,0,43.563-15.659,48.341-37.269a47.99,47.99,0,0,0-3.861-32.043,47.782,47.782,0,0,0,21.355-64.021A47.755,47.755,0,0,0,512,304Z"
                                fill="#24e2b8"
                        />
                      </g>
                    </g>
                    <rect
                            data-v-35e80b9a
                            id="Rectangle_135"
                            data-name="Rectangle 135"
                            width="102"
                            height="309"
                            transform="translate(40 216.667)"
                            fill="#24e2b8"
                    />
                  </g>
                </svg>

                </span>
                          <svg v-else width="21px" height="21px" />
                            <img title="Edit"
                                 @click="$router.push({path: '/company-admin/templates/edit/'+template.templateId})"
                                 src="@/assets/Icon/Edit.svg" alt/>
                            <img title="Delete" @click="showAlert(template.templateId)" src="@/assets/Icon/Delete.svg"
                                 alt/>
                        </th>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col col-lg-6 col-md-7 col-xs-12 per-page">
                <span class="filter_by mr-2 white_space">Show Per Page:</span>
                <div class="primary-input-container choose-type perPage">
                    <primary-select
                            type="text"
                            @input="changePerPage"
                            v-model="per_page" :is-cross="false"
                            class="choose-type perPage"
                            placeholder="Select"
                    >
                        <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
                    </primary-select>
                </div>
            </div>
            <div v-if="!isFound" class="buttons-wrapper">
                <pagination-component
                        @change-page="changePage($event)"
                        :page="Page"
                        :perPage="per_page"
                        :total="TotalPages"
                        :qnt="allTemplates.length"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import {format} from "date-fns";

    export default {
        components: {
            SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            PaginationComponent: () => import("@/components/Pagination.vue"),
            Loader: () => import("@/components/Loader.vue"),
            NotFound: () => import("@/components/NotFound.vue"),
        },
        data: () => ({
            allTemplates: [],
            newTemplates: [],
            isApproved: false,
            TotalPages: null,
            Page: 0,
            SearchTemplate: "",
            pages: [10, 50, 100],
            per_page: 10,
            loading: true,
            isFound: false,
        }),
        created() {
            this.getAllTemplates();
        },
        watch: {
            SearchTemplate() {
                this.Page = 0;
                this.getAllTemplates();
            },
        },
        filters: {
            shortText(txt) {
                return txt.length > 60 ? `${txt.slice(0, 60)}...` : txt;
            },
        },
        methods: {
            changePerPage(e) {
                this.Page = 0;
                this.getAllTemplates();
            },
            changePage(page) {
                this.Page = page;
                this.getAllTemplates();
            },
            showAlert(id) {
                // Use sweetalert2
                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this template!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, delete it!",
                    cancelButtonText: "No, keep it",
                }).then((result) => {
                    if (result.value) {
                        this.$store.dispatch("DeleteTemplate", id).then(() => {
                            this.getAllTemplates();
                            this.$swal(
                                "Deleted!",
                                "Your template has been deleted.",
                                "success"
                            );
                        });
                    }
                });
            },
            getAllTemplates() {
                this.loading = true;
                this.isFound = false;
                this.$store
                    .dispatch("GetAllTemplates", {
                        page: this.Page,
                        per_page: this.per_page ? this.per_page : 10,
                        template_name: this.SearchTemplate,
                    })
                    .then((res) => {
                        this.loading = false;
                        if (!res.items.length && !this.SearchTemplate) {
                            this.$router.push({name: "company-admin-add-template"});
                            return;
                        }
                        if (!res.items.length) {
                            this.isFound = true;
                            return;
                        }
                        console.log(res);
                        this.Page = res.page;
                        this.TotalPages = res.total / res.per_page;
                        this.allTemplates = res.items.map(this.transformTemplates);
                    });
            },
            transformTemplates(i, k) {
                return {
                    templateName: i.template_name,
                    createdBy: i.created_by,
                    createdOn: format(i.created_on, "YYYY:MM:DD HH:mm:ss"),
                    smsText: i.sms_text,
                    templateId: i.sms_template_uuid,
                    status: i.status,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    table.Invoice_table {
        width: 100%;

        th {
            text-align: center;
            padding-left: 0;
            padding-right: 0;
        }

        .action {
            width: 100px;
        }
    }

    table thead tr {
        background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);

        th {
            border-bottom-width: 2px;
            color: white;
            padding-left: 10px;
            vertical-align: bottom;
            border-bottom: 2px solid #dee2e6;
            border: 1px solid #dee2e6;
        }
    }

    table,
    tr {
        width: 100%;
        height: 44px;
        box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
        background-color: #ffffff;
    }

    table tr th {
        padding: 0px 10px 0 20px;
    }

    table {
        border-collapse: collapse;
    }

    .Invoice_table_header th {
        color: white;
        padding-left: 10px;
        border-bottom-width: 2px;
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
        border: 1px solid #dee2e6;
        padding: 0.75rem;
        text-align: center;
    }

    .Invoice_table_header .smsText {
        color: #fff;
        font-weight: bold;
        font-size: 16px;
    }

    .Invoice_table_header th:first-child {
        padding-left: 20px;
        padding-right: 30px;
        width: 14%;
    }

    tbody th:first-child {
        padding-left: 20px;
        padding-right: 30px;
    }

    tbody th {
        color: #212b36;
        font-weight: normal;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 20px;
        padding: 15px 20px;
    }

    .product-container {
        padding: 0 20px;

        .per-page {
            display: flex;
            align-items: center;
            margin-top: 20px;
            padding: 0;
        }

        .perPage {
            width: 80px!important;
        }

        .custom-row {
            width: 100%;
            display: flex;

            span {
                margin-top: 7px;
                margin-left: 20px;
                margin-right: 10px;
            }
        }

        .buttons-wrapper {
            justify-content: flex-end;
        }

        @media (max-width: 891px) {
            .right-wrapprr {
                width: 100% !important;
            }
        }
        @media (max-width: 767px) {
            .add-navigation {
                display: block !important;
                height: auto !important;
            }
            .custom-row {
                width: 100% !important;
            }
            .buttons-wrapper {
                justify-content: flex-start !important;
                margin-top: 15px;
            }
        }
        @media (max-width: 600px) {
            .custom-row {
                display: block !important;
            }

            .buttons-wrapper {
                width: 100% !important;
            }
            .col-lg-6.col-md-7.col-xs-12 {
                margin-top: 15px;
            }
        }

        .add-navigation {
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 40px;
            width: 100%;
            margin-top: 20px;
            margin-bottom: 10px;
            // padding-right: 16px;
            .search-input {
                height: 40px;
                width: 100%;
                background-color: #ffffff;
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 145px;
                }
            }
        }
    }

    .Invoice_table_popup {
        float: right;
        width: 75px;
    }

    .popup_content {
        display: none;
    }

    .popup_cta {
        cursor: pointer;
    }

    .Invoice_table_popup {
        text-align: right;
        position: relative;
        padding: 10px 15px 10px 0;
    }

    // tbody th:first-child {
    //     padding-left: 35px
    // }
    tbody th.created_by {
        line-height: 20px;
        height: 20px;
        padding: 7px 0;
    }

    .Invoice_price {
        font-family: "Helvetica Neue";
        padding: 13px 0 12px 0;
        color: #000000;
        font-weight: bold;
    }

    .Invoice_table_popup.active .popup_content {
        display: block;
        position: absolute;
        right: 0;
        width: 240px;
        border-radius: 4px;
        background-color: #ffffff;
        box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
        padding-left: 0;
        list-style-type: none;
        text-align: left;
    }

    .Invoice_table_popup.active .popup_content a {
        color: #55616e;
        font-size: 16px;
        line-height: 20px;
        text-decoration: none;
        font-family: "Helvetica Neue";
        padding: 10px 15px;
        display: inline-block;
    }

    .popup_image {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: 8px;
    }

    th.user_active:after {
        content: "";
        height: 10px;
        width: 10px;
        background-color: #24e2b8;
        position: absolute;
        border-radius: 50%;
        left: 12px;
        top: 17px;
        // margin: 17px 0 37px 12px;
    }

    th.user_active {
        text-align: left;
        position: relative;
        padding: 12px 0 12px 20px;
    }

    th.smsText {
        // min-height: 25px;
        // max-height: 50px;
        // max-width: 300px;
        // min-width: 250px;
        width: 520px;
        color: #55616e;
        font-family: "Helvetica Neue";
        font-size: 14px;
        font-weight: normal;
        line-height: 25px;
        padding: 10px 0 10px 20px;
    }

    th.status {
        padding: 10px 18px 10px 20px;
        text-align: right;

        .approved {
            box-sizing: border-box;
            height: 24px;
            width: 80px;
            border: 2px solid #ffffff;
            border-radius: 100px;
            background-color: #24e2b8;
            color: #ffffff;
            font-family: "Helvetica Neue";
            font-size: 13px;
            font-weight: normal;
            line-height: 16px;
            padding: 2px 10px 3px;
        }

        .rejected {
            box-sizing: border-box;
            height: 24px;
            width: 80px;
            border: 2px solid #ffffff;
            border-radius: 100px;
            background-color: #d2305b;
            color: #ffffff;
            font-family: "Helvetica Neue";
            font-size: 13px;
            font-weight: normal;
            line-height: 16px;
            padding: 2px 10px 3px;
        }
    }

    th.icon {
        padding: 7px 0 7px 20px;
        text-align: right;
    }

    th.icon svg {
        margin-right: 20px;
        cursor: pointer;
    }

    th .svg-green {
        fill: #24e2b8;
    }

    th .svg-red {
        fill: #d2305b;
    }

    .Invoice_table_sub_header th {
        height: 30px;
        color: #bdbfd8;
        font-family: "Helvetica Neue";
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 1px;
        line-height: 30px;
        padding: 5px 0 5px 15px;
    }

    th.allTemplates {
        padding-top: 20px;
    }

    @media (max-width: 1600px) {
        table.Invoice_table {
            width: 1390px;
        }
    }

    .table_div::-webkit-scrollbar {
        // width: 5px;
        width: 8px;
        height: 8px;
        background-color: #f5f5f5;
    }

    .table_div::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-image: -webkit-gradient(
                        linear,
                        left bottom,
                        left top,
                        color-stop(0.44, #51a3f3),
                        color-stop(0.72, #51a3f3),
                        color-stop(0.86, #51a3f3)
        );
    }
</style>

